import { render, staticRenderFns } from "./RoomBotManage.vue?vue&type=template&id=1a7fdea2"
import script from "./RoomBotManage.vue?vue&type=script&lang=js"
export * from "./RoomBotManage.vue?vue&type=script&lang=js"
import style0 from "./RoomBotManage.vue?vue&type=style&index=0&id=1a7fdea2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports